// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"e9ea4e65","135":"2d53b3ac","184":"ad4e6698","542":"5b6b42fb","561":"3bd31c3b","626":"7b55a901","657":"924e0629","672":"70e39f76"}[chunkId] + ".chunk.js";
};